import React from 'react';
import { FaGift, FaApple, FaGooglePlay, FaQrcode } from 'react-icons/fa';
import './HeroSection.css';
import { Link } from "react-router-dom"

function HeroSection() {
  return (
    <section className="hero-section mb-2">
      <div className='container'>
         <div className="hero-content ">
        <h1 className="home-text mb-5 fw-bold">
          Altoracapital – Where Whales are Made
        </h1>
        <div className="hero-input">
          <input type="text" placeholder="Email / Phone" />
          <Link className='bttn' to="/register">
            <FaGift /> Sign up
          </Link>
        </div>
      </div>
      </div>
    </section>
  );
}

export default HeroSection;
